import {TableConfig} from '@shared/interfaces/table/table-config';
import {ChargeSetupDto} from '@app/api/dmc';
import {DateCellComponent} from '@shared/components/table/cells/date-cell/date-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

const baseColumns: Columns<ChargeSetupDto>[] = [
  {
    title: 'chargeSetup.validFrom',
    key: 'validFrom',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'chargeSetup.validTo',
    key: 'validTo',
    cellRenderer: DateCellComponent,
  },
];

export const chargeinformationChargesetupSinglePriceTable: TableConfig<ChargeSetupDto> = {
  selectable: true,
  selectableType: "single",
  columns: [
    ...baseColumns,
    {
      title: 'chargeSetup.singlePrice',
      key: 'loadLevelNone'
    },
  ]
}

export const chargeinformationChargesetupDifferentiatedTable: TableConfig<ChargeSetupDto> = {
  selectable: true,
  selectableType: "single",
  columns: [
    ...baseColumns,
    {
      title: 'chargeSetup.loadLevelLow',
      key: 'loadLevelLow'
    },
    {
      title: 'chargeSetup.loadLevelHigh',
      key: 'loadLevelHigh'
    },
    {
      title: 'chargeSetup.loadLevelPeak',
      key: 'loadLevelPeak'
    },
  ]
}
